import { render, staticRenderFns } from "./RealEstateAdditionalInfo.vue?vue&type=template&id=37fddd74&"
import script from "./RealEstateAdditionalInfo.vue?vue&type=script&lang=js&"
export * from "./RealEstateAdditionalInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports